import { render, staticRenderFns } from "./VenueDetails.vue?vue&type=template&id=e1ebc0ca&scoped=true"
import script from "./VenueDetails.vue?vue&type=script&lang=js"
export * from "./VenueDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e1ebc0ca",
  null
  
)

export default component.exports